export default (theme) => ({
    iconLink: {
        color: theme.palette.white.main,
    },
    icon: {
        fontSize: 35,
    },
});
